import { get, post } from '@/api/core'

export namespace expert {
  export function projectList(param: { pageNo: number; pageSize: number; keyword?: string }) {
    return get<{
      objects: Array<
        ProjectModels.ProjectListItem & { expertAnalyseStatus: 'untreated' | 'part' | 'completed' }
      >
      hasNext: boolean
      pageNo: number
      pageSize: number
      totalCount: number
      waitCount: number
    }>('/expert/advert_project/list', param)
  }

  /** 获取专家评价 */
  export function getExpertRate(projectId: number) {
    return get<{ data: Models.RateMap; expertAnalyseStatus: 'untreated' | 'part' | 'completed' }>(
      '/expert/advert_project/analyse_info',
      { projectId }
    )
  }

  /** 专家评价 */
  export function expertRate(body: Models.RateInfo & { projectId: number }) {
    return post('/expert/advert_analyse/upsert', {}, body)
  }
}
